/**
 * Läser in det analysexporten behöver utöver det pipelinesidan redan har:
 * kontakter per kund, aktiviteter per lead och Flatbox-offerterna.
 */
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';

async function iOmgangar(ids, fn, storlek = 20) {
  const ut = {};
  for (let i = 0; i < ids.length; i += storlek) {
    const del = ids.slice(i, i + storlek);
    // eslint-disable-next-line no-await-in-loop
    const svar = await Promise.all(del.map(id => fn(id).catch(() => [])));
    del.forEach((id, j) => { ut[id] = svar[j]; });
  }
  return ut;
}

const lasLista = path => getDocs(collection(db, ...path)).then(s => s.docs.map(d => ({ id: d.id, ...d.data() })));

/** Kontakter per kund för leadsens kunder: { companyId: [contact] }. Används också av "Exportera". */
export function laddaKontakter(leads, extraKundIds = []) {
  const kundIds = [...new Set([...leads.map(l => l.companyId), ...extraKundIds].filter(Boolean))];
  return iOmgangar(kundIds, id => lasLista(['crmCompanies', id, 'contacts']));
}

/**
 * @returns {{ contactsByCompany, activitiesByLead, flatboxOffers }}
 *   flatboxOffers är null om de inte gick att läsa (behörighet).
 */
export async function laddaAnalysData(leads, onProgress, extraKundIds = []) {
  onProgress?.('Läser kontakter…');
  const contactsByCompany = await laddaKontakter(leads, extraKundIds);
  onProgress?.('Läser aktiviteter…');
  const activitiesByLead = await iOmgangar(leads.map(l => l.id), id => lasLista(['crmLeads', id, 'activities']));
  onProgress?.('Läser Flatbox-offerter…');
  let flatboxOffers = null;
  try {
    flatboxOffers = (await getDocs(collection(db, 'flatbox_offers'))).docs.map(d => d.data());
  } catch (e) {
    console.warn('Flatbox-offerter kunde inte läsas', e);
  }
  return { contactsByCompany, activitiesByLead, flatboxOffers };
}
